import { Label } from './label'
import { ValidationError } from './validation-error'
import type { FieldError } from 'react-hook-form'
import { memo } from 'react'

/** ラベル＋入力欄＋エラー文の 1 行分。エラー時は .error_input を付けて入力欄の枠を赤くする */
export const FieldBlock = memo(
  ({
    children,
    htmlFor,
    labelText,
    required,
    error
  }: {
    children: React.ReactNode
    labelText: string
    htmlFor: string
    required?: boolean
    error?: FieldError
  }) => {
    const inputClass = error ? 'error_input' : 'done_input'
    return (
      <div className={`relative flex flex-col gap-2 ${inputClass}`}>
        <Label labelText={labelText} htmlFor={htmlFor} required={required} />
        <div>
          {children}
          <ValidationError error={error} />
        </div>
      </div>
    )
  }
)

FieldBlock.displayName = 'FieldBlock'
